interface LighthouseMarkProps {
  /** Rendered size in px (square). Default 24. */
  size?: number
  /** Accessible label. Omit for a purely decorative mark. */
  title?: string
  className?: string
}

/**
 * The Lighthouse brand mark, inlined so it inherits `currentColor`.
 *
 * Inlined rather than referenced as an <img> or CSS mask on purpose: the mark
 * sits on the deep-navy rail and needs to take `--rail-active-fg` (lamp gold)
 * there, but neutral ink elsewhere. currentColor gives that for free, stays
 * crisp at any size, and costs one request fewer than the PNG variants.
 *
 * Source: public/brand/lighthouse_icon_silhouette.svg (24x24 grid).
 */
export function LighthouseMark({ size = 24, title, className }: LighthouseMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79 6.59c-.35-.11-.59.09-.64.37l-.03.18c-.05.29.15.57.5.68l2.73.92c.34.11.61-.01.7-.29l.08-.25c.1-.29-.05-.57-.39-.67L2.79 6.59Zm18.42 0c.35-.11.59.09.64.37l.03.18c.05.29-.15.57-.5.68l-2.73.92c-.34.11-.61-.01-.7-.29l-.08-.25c-.1-.29.05-.57.39-.67l2.95-.94Zm-18.62 2.34c-.33.13-.5.42-.42.71l.06.2c.08.27.36.4.69.28l2.66-.93c.31-.11.45-.37.37-.66l-.07-.23c-.08-.29-.36-.44-.67-.33l-2.62.96Zm18.82 0c.33.13.5.42.42.71l-.06.2c-.08.27-.36.4-.69.28l-2.66-.93c-.31-.11-.45-.37-.37-.66l.07-.23c.08-.29.36-.44.67-.33l2.62.96ZM8.95 4.86c-.45 0-.65-.35-.39-.6L11.3 2.1c.42-.34.99-.34 1.41 0l2.73 2.16c.26.25.06.6-.39.6H13.2v1.66h.6c.37 0 .6.22.6.57v1.55c0 .35-.16.56-.51.68l-.48.17.83 7.23.76.14c.34.06.54.22.7.56l1.27 2.58c.22.44.02.73-.48.73H7.51c-.5 0-.7-.29-.48-.73l1.27-2.58c.16-.34.36-.5.7-.56l.76-.14.83-7.23-.48-.17c-.35-.12-.51-.33-.51-.68V7.09c0-.35.23-.57.6-.57h.6V4.86H8.95Zm2.2 0v2.26h1.7V4.86h-1.7Z"
      />
    </svg>
  )
}
